export default __webpack_public_path__ + "static/media/Zeeshan@300x.5db215fb.png";